import React from "react";
import { ModalBuilder, Table } from "@redriver/cinnamon";
import { TranslatedModal } from "../../../components/modals";

const ApproveRateGroupModal = ({ submitAction, onSubmitted, rateGroup }) => (
  <ModalBuilder
    submitAction={submitAction}
    submitParams={rateGroup.id}
    onSubmitted={onSubmitted}
    renderTrigger={(showModal) => (
      <Table.MenuItem onClick={showModal}>Approve</Table.MenuItem>
    )}
    renderModal={(modalProps) => (
      <TranslatedModal.Delete
        {...modalProps}
        header="Approve Rate Group"
        submitLabel="Approve Rate Group"
      >
        <p>Are you sure you wish to approve '{rateGroup.name}'?</p>
      </TranslatedModal.Delete>
    )}
  />
);

export default ApproveRateGroupModal;
